export default function initCtaBlocks() {
    const blocks = [].slice.call(document.querySelectorAll('.ctaBlock'));

    blocks.forEach(initCtaBlock);
}

function initCtaBlock(root) {
    const imagesJson = root.querySelector('.imagesJson');

    if (imagesJson) {
        const imagesArray = JSON.parse(imagesJson.innerHTML);
        const image = imagesArray[Math.floor(Math.random() * imagesArray.length)];
        const container = root.querySelector('.ctaBlock-backgroundInner');
        if (image.withSepia) {
            container.classList.add('withSepia')
        }
        container.innerHTML = image.image;
    }
}
